// import React, { useState } from "react";

// const RcSearch = () => {
//   const [rcno, setRcno] = useState("");

//   const handleSearch = () => {
//     if (!rcno) {
//       alert("Please enter RC Number");
//       return;
//     }

//     const url = `https://aepos.ap.gov.in/Qcodesearch.jsp?rcno=${rcno}`;

//     // Open in new tab
//     window.open(url, "_blank");
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>RC Search</h2>

//       <input
//         type="text"
//         placeholder="Enter RC Number"
//         value={rcno}
//         onChange={(e) => setRcno(e.target.value)}
//         style={{ padding: "8px", marginRight: "10px" }}
//       />

//       <button onClick={handleSearch} style={{ padding: "8px 16px" }}>
//         Search
//       </button>
//     </div>
//   );
// };

// export default RcSearch; 

//////////////////////



import { useEffect } from "react";

const RcSearch = () => {

  useEffect(() => {
    const rcno = "2802768463"; 

    const url =
      `https://aepos.ap.gov.in/smartepos/Qcodesearch.jsp?rcno=${rcno}`;

    window.location.replace(url);

  }, []);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>Redirecting to Qcodesearch Details...</h1>
    </div>
  );
};

export default RcSearch;